kombi.password = function (event) {
    const password = event.currentTarget.closest('.pattern-form-floating').querySelector('input');
    const type = password.getAttribute('type') === 'password' ? 'text' : 'password';
    password.setAttribute('type', type);
    const eyeIcon = event.currentTarget.querySelector('.eye-icon');
    eyeIcon.classList.toggle('fa-eye-slash');
    eyeIcon.classList.toggle('fa-eye');
}